import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { TreeNode } from 'primeng/api';

// Services
import { TreeViewService } from '@services/treeview.service';

@Component({
  selector: 'app-world-regions',
  templateUrl: './world-regions.component.html',
})
export class WorldRegionsComponent implements OnInit {
  @Input() regionCountries: TreeNode[] = [];
  @Input() selectedBenchmarkCountries: string[] = [];
  @Input() isFilter = false;
  @Input() styleClass = '';

  @Output() afterNodeSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() afterNodeUnSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() afterClick: EventEmitter<any> = new EventEmitter<any>();

  selectedBenchmarkCountryNodes: TreeNode[] = [];

  constructor(private treeviewService: TreeViewService) {}

  ngOnInit() {
    this.treeviewService.checkNode(this.regionCountries, this.selectedBenchmarkCountries, this.selectedBenchmarkCountryNodes);
  }

  nodeSelect(event) {
    this.treeviewService.addNode(event.node, this.selectedBenchmarkCountries);
    this.selectedBenchmarkCountryNodes = [];
    this.treeviewService.checkNode(this.regionCountries, this.selectedBenchmarkCountries, this.selectedBenchmarkCountryNodes);

    if (this.isFilter) {
      this.afterNodeSelect.emit(event);
    }
  }

  nodeUnselect(event, skipParentEvent = false) {
    this.treeviewService.removeNode(event.node, this.selectedBenchmarkCountries);
    this.selectedBenchmarkCountryNodes = [];
    this.treeviewService.checkNodeLocationUnSelect(this.regionCountries, this.selectedBenchmarkCountries, this.selectedBenchmarkCountryNodes);

    if (this.isFilter) {
      if (!skipParentEvent) {
        this.afterNodeUnSelect.emit(event);
      }
    }
  }

  onClick() {
    if (this.isFilter) {
      this.afterClick.emit();
    }
  }
}
